import Behaviour, { mix, DomEvents } from '@/core'
import { Route } from '@/core/router'
import axios from 'axios'
import domify from 'domify'
import { lock } from '@/core/utils'

/**
 *
 * @extends Behaviour
 * @class MobileMenu
 */
export default class Search extends mix(Behaviour).with(DomEvents, Route) {
	constructor(el) {
		super(el)

		this.$searchOverlay = document.getElementById('search-overlay')
		this.$searchForm = document.getElementById('search-form')
		this.$resultsContainer = document.getElementById('search-results')

		this.lock = lock()

		this.searchOpen = false

		// Events.on('route:changed', this.closeSearch)

		/*
      This function must be called to bind the events
    */
		this.addDomEvents()

		/*
      This function must be called to trigger barba events
    */
		this.withRoutes()
	}

	events = {
		'click [data-launch-search]': 'openSearch',
		'click [data-close-search]': 'closeSearch',
		'keyup #search-input': 'runSearch'
	}

	onComplete = () => {
		if (this.searchOpen) this.closeSearch()
	}

	fetch = url => {
		return axios.get(url).then(this.parseHTML)
	}

	parseHTML = ({ data }) => {
		return new Promise(resolve => resolve(data))
	}

	openSearch = (e, $el) => {
		this.searchOpen = true
		document.body.classList.add('has-open-search')
		this.lock.capture()

		// Focus on search input
		if (this.$body.clientWidth >= 1024) {
			document.getElementById('search-input').focus()
			this.$searchOverlay.scrollTop = 0
		}
	}

	closeSearch = (e, $el) => {
		this.searchOpen = false
		document.body.classList.remove('has-open-search')
		this.lock.release()
	}

	runSearch = (e, $el) => {
		const query = $el.value
		const action = '/search.json'
		const searchUrl = `${action + '?q=' + query}`

		if (query.length >= 4) {
			this.fetch(searchUrl).then(data => {
				while (this.$resultsContainer.firstChild) {
					this.$resultsContainer.removeChild(this.$resultsContainer.firstChild)
				}

				this.$resultsContainer.appendChild(
					domify(data.results.map(this.searchResult).join(''))
				)
			})
		}
	}

	searchResult = ({ title, url, sectionName, postDate }) => {
		return `<li class="block">
				<a class="block-item block" href="${url}">
					<div class="meta block-item__meta">
						<span class="meta__diamond color-senior">	
							<i class="icon icon--diamond">
								<svg>
									<use class="no-barba" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#diamond"></use>
								</svg>
							</i>
						</span>
						<span class="meta__date">${postDate}</span>
						<span class="meta__line"></span>
						<span class="meta__category">${sectionName}</span>
					</div>
					<h5 class="h4 block-item__title">${title}</h5>
				</a>
			</li>`
	}
}
